<template>
  <el-dialog
    width="760px"
    :title = "$t('uploadImg.上传图片')"
    v-bind="$attrs"
    class="dialog-dark"
    @close="onClose"
    v-on="$listeners"
  >
    <el-form
      ref="elForm"
      :model="form"
      :rules="rules"
      label-position="right"
      label-width="100px"
      class="form-dark"
      size="small"
      @submit.native.prevent
    >
      <el-form-item label-width="0" prop="url">
        <el-upload
          class="picture-card"
          list-type="picture-card"
          accept="image/*"
          :show-file-list="false"
          :data="dataObj"
          :action="uploadUrl"
          :on-success="uploadSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="form.url" :src="form.url" class="uploader-avatar" />
          <div class="uploader-empty" :class="{ 're-uploader': form.url }">
            <template v-if="!form.url">
              <i class="el-icon-plus uploader-icon"></i>
              <div>{{$t('uploadImg.添加图片')}}</div>
            </template>
            <div class="re-uploader-btn" v-else>{{$t('uploadImg.重新上传')}}</div>
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item :label = "$t('uploadImg.设置链接')" prop="link">
        <el-input
          v-model.trim="form.link"
          :placeholder="$t('uploadImg.请输入')"
          :maxlength="1024"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="button-mini" size="mini" @click="close"
        >{{$t('uploadImg.取消')}}</el-button
      >
      <el-button
        class="button-mini"
        type="primary"
        size="mini"
        :disabled="!form.url"
        @click="ok"
        >{{$t('uploadImg.确定')}}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { uuid } from "@/utils/global";
export default {
  name: "NickName",
  props: {},
  data() {
    var checkLink = (rule, value, callback) => {
      if (!value) {
        return callback();
      }
      if (/^https?:\/\//.test(value)) {
        return callback();
      }
      return callback(new Error(this.$t('uploadImg.请输入')));
    };
    return {
      uploadUrl: `${config.uploadUrl}/info/upload/deal`,
      form: {
        url: "",
        link: "",
      },
      rules: {
        link: [{ validator: checkLink, trigger: "blur" }],
      },
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    role() {
      //3:主播 2：助手 1：嘉宾
      return this.$store.getters.selfParticipant?.type;
    },
    chatRoomId() {
      return this.$store.getters.chatRoomId;
    },
    ccWebsocketClient() {
      return this.$store.getters.ccWebsocketClient;
    },
    dataObj() {
      return { siteId: "" };
    },
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    onClose() {
      this.$refs.elForm.resetFields()
    },
    ok() {
      this.$refs.elForm.validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    async submit() {
      // TODO: 消息处理
      let head = {
        cmd: 1701,
        id: this.getChatHeadId(),
        room_id: this.chatRoomId,
      };
      let Body = {
        role: this.role == 3 ? 6 : 7,
        name: this.userInfo.name,
        imgUrl: this.form.url,
        imgState: true,
      };
      if (this.form.link) {
        Body.imgLinkUrl = this.form.link;
      }
      await this.ccWebsocketClient.customizeSendMsg(head, Body);
      this.close();
    },
    getChatHeadId() {
      return `${uuid(15, 62)}${new Date().getTime()}`;
    },
    /**文件上传成功 */
    uploadSuccess(res) {
      if (res.code === 0) {
        this.form.url = res.data[1];
      } else {
        this.$message.error(this.$t('uploadImg.图片格式错误'));
      }
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error(this.$t('uploadImg.图片大小超过请重新选取'));
      }
      return isLt2M;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-dark {
  width: 366px;
  margin: 0 auto;
  padding: 30px 0 72px;
}
.uploader-icon {
  font-size: 19px;
  color: #fff;
  margin-bottom: 6px;
}
.uploader-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  line-height: 1;
  font-size: 12px;
  color: #a0a0a0;
}
.picture-card {
  display: flex;
  justify-content: center;
  ::v-deep .el-upload {
    position: relative;
    width: 160px;
    height: 160px;
    line-height: 158px;
    background-color: transparent;
    border-color: #a0a0a0;
    overflow: hidden;
  }
}
.form-dark ::v-deep {
  .el-form-item:not(.is-error) {
    .el-input__inner,
    .el-textarea__inner {
      border-color: #525366;
    }
  }
}
.uploader-avatar {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.re-uploader {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.picture-card ::v-deep .el-upload:hover {
  .re-uploader {
    background-color: rgba($color: #000000, $alpha: 0.5);
    display: flex;
  }
}

.re-uploader-btn {
  width: 70px;
  height: 26px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 24px;
  border-radius: 2px;
  border: 1px solid #fff;
  box-sizing: border-box;
}
</style>
